import styled, { createGlobalStyle } from 'styled-components'

import RubikBold from '@/assets/fonts/Rubik-Bold.ttf'
import RubikBoldWoff2 from '@/assets/fonts/Rubik-Bold.woff2'
import RubikLight from '@/assets/fonts/Rubik-Light.ttf'
import RubikLightWoff2 from '@/assets/fonts/Rubik-Light.woff2'
import RubikMedium from '@/assets/fonts/Rubik-Medium.ttf'
import RubikMediumWoff2 from '@/assets/fonts/Rubik-Medium.woff2'
import RubikRegular from '@/assets/fonts/Rubik-Regular.ttf'
import RubikRegularWoff2 from '@/assets/fonts/Rubik-Regular.woff2'
import RubikSemiBold from '@/assets/fonts/Rubik-SemiBold.ttf'
import RubikSemiBoldWoff2 from '@/assets/fonts/Rubik-SemiBold.woff2'
import { properties } from '@/styles/properties'
import { variables } from '@/styles/variables'

export const GlobalStyles = createGlobalStyle`
  @font-face {
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 300;
      src: url(${RubikLightWoff2}) format('woff2'),
      url(${RubikLight}) format('truetype');

  }
  @font-face {
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 400;
      src: url(${RubikRegularWoff2}) format('woff2'),
      url(${RubikRegular}) format('truetype');
  }

  @font-face {
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 500;
      src: url(${RubikMediumWoff2}) format('woff2'),
      url(${RubikMedium}) format('truetype');

  }

  @font-face {
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 600;
      src: url(${RubikSemiBoldWoff2}) format('woff2'),
       url(${RubikSemiBold}) format('truetype');
  }

  @font-face {
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 700;
      src: url(${RubikBoldWoff2}) format('woff2'),
      url(${RubikBold}) format('truetype');
  }

  ${properties}

  :root {
    --toastify-toast-width: 400px;
    --toastify-toast-min-height: 14px;
    --toastify-toast-max-height: 800px;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    outline: none;
    caret-color: transparent;
  }

  ul[class],
  ol[class] {
    padding: 0;
  }

  body,
  h1,
  h2,
  h3,
  h4,
  p,
  ul[class],
  ol[class],
  li,
  figure,
  figcaption,
  blockquote,
  dl,
  dd {
    margin: 0;
  }

  ul[class],
  ol[class] {
    list-style: none;
  }

  p,
  div,
  h1,
  h2 {
    white-space: pre-line;
  }

  a:not([class]) {
    text-decoration-skip-ink: auto;
  }

  img {
    max-width: 100%;
    display: block;
  }

  article > * + * {
    margin-top: 1em;
  }

  input,
  button,
  textarea,
  select {
    font: inherit;
    &:focus {
      outline: none;
    }
  }

  button,
  input[type='submit'],
  input[type='reset'] {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }

  a {
    text-decoration: none;
  }

  body {
    overflow: hidden;
    text-rendering: optimizeSpeed;
    line-height: 1.5;
    background: ${(props) => props.theme.colors.body};
    color: ${(props) => props.theme.colors.text};
    font-family: ${variables.fontFamily};
    font-weight: 500;
  }

  .App {
    font-family: ${variables.fontFamily}, -apple-system, BlinkMacSystemFont,
      'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
      'Droid Sans', 'Helvetica Neue', sans-serif;
    font-size: ${variables.fontSize};
    line-height: ${variables.lineHeight};
    position: relative;
    height: 1080px;
    width: 1920px;
    overflow: hidden;

    /* May lead to chrome craches (v107) */
    /* transition: --appBgStart 0.5s, --appBgEnd 0.5s; */
    /* background: radial-gradient(85.28% 210.12% at 10.34% 14.72%, var(--appBgStart) 0%, var(--appBgEnd) 100%); */
    background: radial-gradient(
      85.28% 210.12% at 10.34% 14.72%,
      ${(props) => props.theme.colors.app.background.start} 0%,
      ${(props) => props.theme.colors.app.background.end} 100%
    );

    > .loader {
      z-index: 1;
    }
  }

  .content-wrapper {
    padding: 0 0 0 224px;
  }
  .content-wrapper-wihtout-paddings {
    padding: 0;
  }

  .dn {
    display: none;
  }

  .Toastify__toast {
    margin-bottom: 0px;
  }

  .Toastify__toast-container {
    font-family: ${variables.fontFamily};
    font-size: 14px;
    line-height: 1.25;
  }

  // Debug setFocus

/*   .isFocused {
    border: 2px dashed red;
  }

  .isFocusedLeaf {
    border: 2px dashed green;
  } */

  .focusDisabled {
    pointer-events: none;
  }
  ::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }

  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`

export const Box = styled.div``
